<template>
    <div class="app-body ">
        <div class="a-flex-rsbc">
            <bread-crumb></bread-crumb>
        </div>
        <el-card class="el-main">
            <el-form :model="form" ref="form" label-width="125px" label-position="left">
                <el-form-item label="提交模式" prop="billWay">
                    <el-radio-group v-model="form.billWay" @change='billWayChange'>
                        <el-radio :label="1">账单缴费</el-radio>
                        <el-radio :label="2">电表缴费</el-radio>
                        <!-- <el-radio :label="3">服务费缴费</el-radio> -->
                    </el-radio-group>
                </el-form-item>
                <!-- <el-form-item label="电费项目" label-width="125px" prop="projectId" v-if="form.billWay == 1">
                    <div class="a-flex-rfsc">
                        <le-select-remote-search
                            large
                            style="padding: 0 !important;" 
                            v-model="form.projectId" 
                            :options="optionsProject" 
                            placeholder="请选择电费项目(可搜索)" />
                    </div>
                </el-form-item> -->
                <el-form-item label="电费项目" label-width="125px" prop="projectIdList" v-if="form.billWay == 1">
                    <div class="a-flex-rfsc">
                        <el-select v-model="chargeFeeType" placeholder="请选择" clearable @change='chargeFeeTypeChange'>
                            <el-option v-for="item in chargeFeeTypeDic"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <le-select-remote-search
                            large
                            multiple
                            collapse
                            style="padding: 0 !important;" 
                            v-model="form.projectIdList" 
                            :options="optionsProject" 
                            :disabled="chargeFeeType?false:true"
                            placeholder="请选择电费项目(可搜索)" />
                        <el-button class="a-ml-10" type="primary" @click="handleChangeBillType">查询</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="电表号" prop="ammeterId" v-if="form.billWay == 2">
                    <le-select-remote-search
                        large
                        style="padding: 0 !important; width: 300px" 
                        v-model="form.ammeterId" 
                        :options="optionsAmmeter" 
                        placeholder="请选择电表(可搜索)" />
                </el-form-item>
                <!-- <el-form-item label="计费方式" prop="billFeeWay" v-if="form.billWay == 3">
                    <le-select-local-search 
                        style="padding: 0 !important; width: 200px" 
                        v-model="form.billFeeWay" 
                        :options="billFeeWayDic" />
                </el-form-item> -->
                <el-form-item label="备注" prop="remark">
                    <el-input
                        style="width: 400px;"
                        type="textarea"
                        :autosize="{ minRows: 4 }"
                        placeholder="请输入内容"
                        maxlength="500"
                        show-word-limit
                        v-model="form.remark">
                    </el-input>
                </el-form-item>
                <div class="a-flex-rfsc a-c-333 a-fs-14" style="margin-bottom: 10px" v-if="form.billWay == 1">
                    <el-checkbox-group v-model="form.billTypeList" size="small">
                        <el-checkbox :label="1" :border='true' style="margin-right: 0 !important">电费</el-checkbox>
                        <el-checkbox :label="2" :border='true'>服务费</el-checkbox>
                    </el-checkbox-group>
                    <span class="a-ml-40">电费缴纳：￥{{ electricFeeTotal }}</span>
                    <span class="a-ml-40">服务费缴纳：￥{{ serviceFeeTotal }}</span>
                </div>
                <!-- <el-form-item prop="pictureList" label="发票">
                    <le-upload-file-img-ly ref="pic" v-model="form.pictureList" :limit='10'></le-upload-file-img-ly>
                </el-form-item> -->
                <electric-charge-add-bill 
                    :tableData.sync="tableDataBill" 
                    :chargeFeeType="chargeFeeType" 
                    @recordTimeChange='recordTimeChange'
                    @lastRecordTimeChange='lastRecordTimeChange'
                    @intervalIncomeChange='intervalIncomeChange'
                    v-show="form.billWay == 1 && form.billTypeList.indexOf(1) != -1">
                </electric-charge-add-bill>
                <electric-charge-add-ammeter 
                    :tableData.sync="tableDataAmmeter" 
                    :chargeFeeType="chargeFeeType" 
                    @recordTimeChange='recordTimeChange'
                    @lastRecordTimeChange='lastRecordTimeChange'
                    ref="electricChargeAddAmmeter"
                    v-show="form.billWay == 2">
                </electric-charge-add-ammeter>
                <electric-charge-add-service
                    class="a-mt-20"
                    :tableData.sync="tableDataService" 
                    :billFeeWay='form.billFeeWay'
                    ref="electricChargeAddService"
                    @recordTimeChange='recordTimeChange'
                    @lastRecordTimeChange='lastRecordTimeChange'
                    v-show="form.billWay == 1 && form.billTypeList.indexOf(2) != -1"
                    ></electric-charge-add-service>
                <div style="height: 70px;"></div>
            </el-form>
            
        </el-card>
        <div class="a-line-t-e0 footerBox">
            <el-button type="primary" class="a-ml-24 a-mt-15" @click="submit">立即提交</el-button>
            <el-button class="a-ml-24 a-mt-15" style="margin-left: 24px" @click="cancelSubmit">返回</el-button>
        </div>
    </div>
</template>

<script>
    import util from '../../../src/utils/util'
    import ElectricChargeAddAmmeter from './child/electric-charge-add-ammeter.vue'
    import electricChargeAddBill from './child/electric-charge-add-bill.vue'
    import electricChargeAddService from './child/electric-charge-add-service.vue'
    export default {
    components: { electricChargeAddBill, ElectricChargeAddAmmeter, electricChargeAddService },
        data () {
            return {
                debounceTimeout: null,
                util: util,
                tableDataBill: [], // 账单缴费数据
                tableDataAmmeter: [], // 电表缴费数据
                tableDataService: [],
                chargeFeeType: '2',//电费收取方式:1:预充值,2先用后付
                form: {
                    billTypeList: [1], //1--缴电费，2--缴服务费
                    billType: 1, //1--缴电费，2--缴服务费
                    billWay: 1,
                    projectId: '',
                    projectIdList: [],
                    ammeterId: '',
                    currentDate: this.$getDay.getToday(),
                    lastDate: '',
                    remark: '',
                    billFeeWay: '2'
                },
                optionsProject: {
                    url: this.$Config.apiUrl.electricFilter,
                    method: "post",
                    params: {
                        chargeFeeType: '2'
                    },
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "id",
                    searchKey: "name",
                    pageSize: 100
                },
                optionsAmmeter: {
                    url: this.$Config.apiUrl.ammeterFilter,
                    method: "post",
                    params: {},
                    showLoading: false,
                    labelKey: "name",
                    valueKey: "id",
                    searchKey: "name",
                    pageSize: 100
                },
                billFeeWayDic: [{
                    label: '按电量计费',
                    value: '1'
                },{
                    label: '按周期计费',
                    value: '2'
                }],
                chargeFeeTypeDic: [],
                totalElectricIntervalIncome: 0
            }
        },
        computed: {
            serviceFeeTotal () {
                if(this.form.billTypeList.indexOf(2) == -1 || !this.tableDataService.length || this.form.billWay == 2){
                    return 0
                }else {
                    return this.tableDataService[0].needPayAmount
                }
            },
            electricFeeTotal () {
                if(this.form.billWay == 1) {
                    //账单缴费
                    if(this.tableDataBill.length) {
                        let needPayAmountObj = {} // 存储每一个电表的应付费用 或 预缴费用
                        let totalFee = 0
                        this.tableDataBill.map(item=>{
                            if(!needPayAmountObj[item.ammeterNo]) {
                                if(this.chargeFeeType == 1) {
                                    needPayAmountObj[item.ammeterNo] = item.prePayAmount
                                    totalFee = this.$decimal.decimal_add(totalFee, (item.prePayAmount || 0))
                                }else {
                                    needPayAmountObj[item.ammeterNo] = item.needPayAmount
                                    totalFee = this.$decimal.decimal_add(totalFee, (item.needPayAmount || 0))
                                }
                            }
                        })
                        return totalFee
                    }else {
                        return 0
                    }
                }else if(this.form.billWay == 2){
                    //电表缴费
                    if(this.tableDataAmmeter.length) {
                        let ammeterInfo = this.tableDataAmmeter[0]
                        if(this.chargeFeeType == 1) {
                            return ammeterInfo.needPayAmount ? (ammeterInfo.needPayAmount / 100).toFixed(2) : 0
                        }else {
                            return ammeterInfo.needPayAmount
                        }
                    }else {
                        return 0
                    }
                }else {
                    return 0
                }
            }
        },
        watch: {
            'form.ammeterId': {
                handler (val) {
                    if(val) {
                        this.getBillInfoForm()
                    }
                }
            },
            'form.currentDate': {
                handler (val) {
                    if(val) {
                        if(this.form.billWay == 1) {
                            this.handleChangeBillType()
                        }else {
                            this.getBillInfoForm()
                        }
                    }
                }
            },
            'form.lastDate': {
                handler (val) {
                    if(val) {
                        if(this.form.billWay == 1) {
                            this.handleChangeBillType()
                        }else {
                            this.getBillInfoForm()
                        }
                    }
                }
            },
        },
        created () {
            this.$getDic('chargeFeeType','select').then(res=>{ this.chargeFeeTypeDic = res; })
        },
        methods:{
            billWayChange () {
                this.form.ammeterId = ''
                this.form.projectId = ''
                this.form.remark = ''
                this.chargeFeeType = '2'
            },
            recordTimeChange (val) {
                this.form.currentDate = val
            },
            lastRecordTimeChange (val) {
                this.form.lastDate = val
            },
            intervalIncomeChange (val) { //填写电费的区间收益时，自动填充对应服务费的区间收益
                this.totalElectricIntervalIncome = 0 // 电费账单的总区间收益
                if(this.tableDataBill.length) {
                    let intervalIncomeObj = {} // 存储每一个站点的区间收益
                    this.tableDataBill.map(item=>{
                        if(!intervalIncomeObj[item.stationId]) {
                            intervalIncomeObj[item.stationId] = item.intervalIncome
                            this.totalElectricIntervalIncome = this.$decimal.decimal_add(this.totalElectricIntervalIncome, (item.intervalIncome || 0))
                        }
                    })
                }

                this.tableDataService.map(item=>{
                    item.totalProfit = this.totalElectricIntervalIncome
                })
            },
            chargeFeeTypeChange (val) {
                this.optionsProject.params.chargeFeeType = this.chargeFeeType
                this.form.billTypeList = [1]
                this.form.billType = 1
                this.form.projectIdList = []
                this.form.currentDate = this.$getDay.getToday()
                this.form.lastDate = ''
                this.form.remark = ''
                this.tableDataBill = []
                this.tableDataService = []
            },
            handleChangeBillType () {
                this.getBillInfoForm(1)
                this.getBillInfoForm(2)
            },
            getBillInfoForm (billType = 1) {
                let reqData = {}
                if(this.form.billWay == 1) {
                    // 账单缴费
                    reqData = {
                        ...this.form,
                        billType: billType, //1--缴电费，2--缴服务费
                        billWay: 1,
                        // billFeeWay: '1'
                    }
                }else if(this.form.billWay == 2) {
                    // 电表缴费
                    reqData = {
                        ...this.form,
                        billType: billType, //1--缴电费，2--缴服务费
                        billWay: 2,
                        // billFeeWay: '1'
                    }
                }
                this.$Axios._post({
                    url: this.$Config.apiUrl.electricBillInfo,
                    method: "post",
                    params: {
                        ...reqData
                    }
                })
                .then(res=>{
                    if (res.result.code == 0) {
                        let resData = res.result.data.list
                        let arr = []
                        let remarkArr = []
                        let remarkNum = 0
                        let serviceUnitPrice = 0
                        resData.map(ite=>{
                            ite.billAmmeterRecordResultList.map(item=>{
                                let obj = {
                                    ...item,
                                    currentFee: ite.currentFee,
                                    intervalRatio: ite.intervalRatio,
                                    projectId: ite.projectId,
                                    projectName: ite.projectName,
                                    ratio: ite.ratio,
                                    totalEnergy: ite.totalEnergy,
                                    totalPay: ite.totalPay,
                                    totalProfit: ite.totalProfit,
                                    unitPrice: ite.unitPrice,
                                    recordTime: this.form.currentDate || this.$getDay.getToday(),
                                    lastRecordTime: this.form.lastDate || item.lastRecordTime,
                                    lastRecordTimeReadoOnly: reqData.billType == 1 ? item.lastRecordTime : '', //交电费判断条件是是否有上次抄表时间， 缴服务费则都可编辑
                                    predictEnergy: item.predictEnergy,//估算电量
                                    outsideEnergy: item.outsideEnergy,//估算他方电量
                                    inputEnergy: '',//抄表电量
                                    deviceNumId: item.ammeterId,
                                    recordTimeId: this.form.billWay == 2 ? item.projectId : 999999999,//交电费按项目合并， 缴服务费所有项目都合并
                                    recordPowerId: item.ammeterId,
                                    remainMoneyId: item.ammeterId,
                                    prePayAmountId: item.ammeterId,
                                    needPayAmountId: reqData.billType == 1 ? item.ammeterId : 999999999,//交电费按电表合并， 缴服务费所有项目都合并
                                    lastRecordTimeId: this.form.billWay == 2 ? item.projectId : 999999999,//交电费按项目合并， 缴服务费所有项目都合并
                                    lastRecordPowerId: item.ammeterId,
                                    lastPrePayAmountId: item.ammeterId,
                                    lastRemainMoneyId: item.ammeterId,
                                    unitPriceId: ite.projectId,
                                    billUnitPriceId: 999999999,
                                    serviceUnitPriceId: ite.projectId,
                                    intervalIncomeId: item.stationId,//交电费按站点合并， 缴服务费所有项目都合并
                                    stationIncomeRatioId: item.ammeterId,
                                    totalProfitId: reqData.billType == 1 ? ite.projectId : 999999999,//交电费按站点合并， 缴服务费所有项目都合并   ite.projectId,
                                    totalPayId: ite.projectId,
                                    intervalRatioId: item.ammeterId,
                                    ratioId: ite.projectId,
                                    periodPowerId: item.ammeterId,
                                    predictEnergyId: item.ammeterId
                                }
                                arr.push(obj)
                            })
                            if(ite.remark) {
                                // 填充默认备注
                                remarkArr.push(ite.projectName + '：' +ite.remark)
                                remarkNum += ((ite.projectName + '：' +ite.remark).length)
                            }
                            serviceUnitPrice += Number(ite.serviceUnitPrice || 0) // 计算所有项目的默认服务总和
                        })
                        if(remarkNum > 500) {
                            this.$message.warning('备注字数超过上限')
                        }else if(this.form.billWay == 1){
                            this.form.remark = remarkArr.join('；\n')
                        }
                        let uniqArr = JSON.parse(JSON.stringify(arr))
                        uniqArr = this.uniqueArrAmmeter(uniqArr)
                        let totalProfit = 0
                        let arrOnlyStation = [...arr]
                        arrOnlyStation = this.uniqueArr(arrOnlyStation) //站点去重后的列表数据
                        arrOnlyStation.map(item=>{ // 按比例计算收益合计
                            // totalProfit += (Number(item.intervalIncome || 0) * Number(item.stationIncomeRatio))
                            totalProfit += Number(item.intervalIncome || 0)
                        })
                        if(this.form.billWay == 1) {
                            if(billType == 1) {
                                this.tableDataBill = arr.map(item=>{
                                    return {
                                        ...item,
                                        totalProfit: totalProfit,
                                        deviceNumByRadio: item.deviceNumByRadio || '0',
                                        slotNumByRadio: item.slotNumByRadio || '0',
                                        intervalIncome: item.intervalIncome ? (item.intervalIncome/100).toFixed(2) : 0
                                    }
                                })
                            }else if(billType == 2) {
                                this.tableDataService = arr.map(item=>{
                                    return {
                                        ...item,
                                        totalProfit: totalProfit ? (totalProfit/100).toFixed(2) : 0, //这里的区间收益 视为整个账单的区间收益，所以是所有站点的区间收益
                                        needPayAmount: serviceUnitPrice ? (serviceUnitPrice / 100).toFixed(2) : '',//默认服务费
                                    }
                                })
                            }
                            if(arr && arr.length) {
                                this.form.lastDate = arr[0].lastRecordTime
                            }
                            this.intervalIncomeChange()
                        }else if(this.form.billWay == 2) {
                            this.chargeFeeType = resData[0].chargeFeeType || 1
                            this.tableDataAmmeter = arr.map(item=>{
                                return {
                                    ...item,
                                    totalProfit: totalProfit,
                                    deviceNumByRadio: item.deviceNumByRadio || '0',
                                    slotNumByRadio: item.slotNumByRadio || '0',
                                    intervalIncome: item.intervalIncome ? (item.intervalIncome/100).toFixed(2) : 0
                                }
                            })

                            this.$refs['electricChargeAddAmmeter'].originTableData = JSON.parse(JSON.stringify(this.tableDataAmmeter))
                        }
                        
                    } else {
                        this.$message.error(res.result.message)
                    }
                })
                .catch(err=>{
                    console.log(err);
                })
            },
            async submit () {
                let requestData = []
                let checkResult, reqData, apiUrl = ''
                if(this.form.billWay == 1) {
                    if(!this.form.billTypeList.length) {
                        this.$message.error('请至少填写一种费用')
                        return
                    }
                    apiUrl = this.$Config.apiUrl.addBothBill
                    reqData = {}
                    if(this.form.billTypeList.length > 1) {
                        // 既勾选了电费  又勾选了服务费
                        if(this.totalElectricIntervalIncome != this.tableDataService[0].totalProfit) {
                            this.$message.error('电费账单的区间收益应与服务费账单的区间收益相等')
                            return
                        }

                        if(this.tableDataBill[0].lastRecordTime != this.tableDataService[0].lastRecordTime) {
                            this.$message.error('电费账单的计费开始时间应与服务费账单的计费开始时间相等')
                            return
                        }
                        if(this.tableDataBill[0].recordTime != this.tableDataService[0].recordTime) {
                            this.$message.error('电费账单的计费结束时间应与服务费账单的计费结束时间相等')
                            return
                        }
                    }
                    // 电费
                    if(this.form.billTypeList.indexOf(1) != -1) {
                        requestData = this.tableDataBill
                        checkResult = await this.checkRules(requestData)
                        if(checkResult) {
                            this.$message.error(checkResult)
                            return
                        }
                        requestData = requestData.map(item=>{
                            return {
                                ...item,
                                needPayAmount:  this.chargeFeeType == 2 ? Number((item.needPayAmount*100).toFixed(0)) : item.needPayAmount,
                                prePayAmount: (item.prePayAmount*100).toFixed(0),
                                remainMoney: (item.remainMoney*100).toFixed(0),
                                finalRemainMoney: ((Number(item.remainMoney) + Number(item.prePayAmount)) * 100).toFixed(0),
                                intervalRatio: (item.intervalRatio*100).toFixed(0),
                                intervalIncome: (item.intervalIncome*100).toFixed(0),
                                ratio: (item.ratio*100).toFixed(0),
                                billUnitPrice: parseFloat(item.billUnitPrice).toFixed(3),
                                outsideEnergy: item.outsideEnergy,
                                innerPrice: item.innerPrice,
                                outsidePrice: item.outsidePrice
                            }
                        })
                        this.$set(reqData, 'electricBill', {
                            ammterBillList: requestData,
                            billDate: requestData[0].recordTime,//账单时间
                            billDateStart: requestData[0].lastRecordTime,//账单开始时间 - 取上次抄表时间
                            chargeFeeType: this.chargeFeeType,
                            projectId: requestData[0].projectId,
                            projectPowerRate: requestData[0].ratio,//总电费收益占比 * 100
                            totalIntervalFee: requestData[0].totalPayAllProject,//应付合计
                            totalIntervalIncome: requestData[0].totalProfitAllProject,//收益合计
                            totalIntervalPower: requestData[0].totalIntervalPower,//抄表总度数
                            unitPrice: requestData[0].unitPrice,//电费单价
                            billUnitPrice: requestData[0].billUnitPrice,//账单电费单价
                            billWay: 1,
                            billType: 1, //1--缴电费，2--缴服务费
                            remark: this.form.remark
                        })
                    }
                    

                    // 服务费
                    if(this.form.billTypeList.indexOf(2) != -1) {
                        requestData = this.tableDataService
                        checkResult = await this.checkServiceRules(requestData)
                        if(checkResult) {
                            this.$message.error(checkResult)
                            return
                        }
                        requestData = requestData.map(item=>{
                            let ratio = 0
                            if(Number(item.totalProfit)) {
                                ratio = parseInt((Number(item.needPayAmount) / Number(item.totalProfit))*10000).toFixed(0)
                            }else {
                                // 收益为0， 电费占比视为100%
                                ratio = 10000
                            }
                            return {
                                ...item,
                                needPayAmount: Number((item.needPayAmount*100).toFixed(0)),
                                totalProfit: Number((item.totalProfit*100).toFixed(0)),
                                ratio: ratio,
                                // outsideEnergy: item.outsideEnergy,
                                // innerPrice: item.innerPrice,
                                // outsidePrice: item.outsidePrice
                            }
                        })
                        this.$set(reqData, 'serviceBill', {
                            ammterBillList: requestData,
                            billDate: requestData[0].recordTime,//账单时间
                            billDateStart: requestData[0].lastRecordTime,//账单开始时间 - 取上次抄表时间
                            projectPowerRate: requestData[0].ratio,//总电费收益占比 * 100
                            totalIntervalFee: requestData[0].needPayAmount,//应付合计
                            totalIntervalIncome: requestData[0].totalProfit,//收益合计
                            chargeFeeType: 2,// 服务费都默认后付
                            billWay: 1,
                            billType: 2, //1--缴电费，2--缴服务费
                            remark: this.form.remark
                        })
                    }
                    
                }else if(this.form.billWay == 2) {
                    apiUrl = this.$Config.apiUrl.electricBillAdd
                    requestData = this.tableDataAmmeter
                    checkResult = await this.checkRules(requestData)
                    if(checkResult) {
                        this.$message.error(checkResult)
                        return
                    }
                    requestData = requestData.map(item=>{
                        return {
                            ...item,
                            needPayAmount:  this.chargeFeeType == 2 ? Number((item.needPayAmount*100).toFixed(0)) : item.needPayAmount,
                            prePayAmount: (item.prePayAmount*100).toFixed(0),
                            remainMoney: (item.remainMoney*100).toFixed(0),
                            finalRemainMoney: ((Number(item.remainMoney) + Number(item.prePayAmount)) * 100).toFixed(0),
                            intervalRatio: (item.intervalRatio*100).toFixed(0),
                            intervalIncome: (item.intervalIncome*100).toFixed(0),
                            ratio: (item.ratio*100).toFixed(0),
                            billUnitPrice: parseFloat(item.billUnitPrice).toFixed(3),
                            outsideEnergy: item.outsideEnergy,
                            innerPrice: item.innerPrice,
                            outsidePrice: item.outsidePrice
                        }
                    })
                    reqData = {
                        ammterBillList: requestData,
                        billDate: requestData[0].recordTime,//账单时间
                        billDateStart: requestData[0].lastRecordTime,//账单开始时间 - 取上次抄表时间
                        chargeFeeType: this.chargeFeeType,
                        projectId: requestData[0].projectId,
                        projectPowerRate: requestData[0].ratio,//总电费收益占比 * 100
                        totalIntervalFee: requestData[0].totalPay,//应付合计
                        totalIntervalIncome: requestData[0].totalProfit,//收益合计
                        totalIntervalPower: requestData[0].totalIntervalPower,//抄表总度数
                        unitPrice: requestData[0].unitPrice,//电费单价
                        billUnitPrice: requestData[0].billUnitPrice,//账单电费单价
                        billWay: 2,
                        billType: 1, //1--缴电费，2--缴服务费
                        remark: this.form.remark
                    }
                }
                const h = this.$createElement;
                this.$msgbox({
                    title: '温馨提示',
                    message: h('div', null, [
                        h('p', { style: 'color: #333;font-size: 16px' }, `账单金额￥${this.$decimal.decimal_add(this.electricFeeTotal, this.serviceFeeTotal)}`),
                        h('p', { style: 'color: #666;font-size: 13px' }, `电费金额￥${this.electricFeeTotal}`),
                        h('p', { style: 'color: #666;font-size: 13px' }, `服务费￥${this.serviceFeeTotal}`),
                    ]),
                })
                .then(_=>{
                    this.$Axios._post({
                        url: apiUrl,
                        method: "post",
                        params: {
                            ...reqData
                        }
                    })
                    .then(res=>{
                        this.$message.success('操作成功')
                        this.$router.replace('/electric/electric-charge-bill')
                        // this.$router.back()
                        this.$store.dispatch("delView", this.$route);
                        this.$destroy();
                        // this.$refs['form'].resetFields()
                        // this.tableDataBill = []
                        // this.tableDataAmmeter = []
                        // this.tableDataService = []
                        // this.form.projectIdList = []
                    })
                    .catch(err=>{

                    })
                })
                .catch(_=>{})
            },
            cancelSubmit () {
                this.$confirm('是否确认返回？','温馨提示')
                .then(_=>{
                    this.$router.back()
                    this.$store.dispatch("delView", this.$route);
                    this.$destroy();
                    // this.$refs['form'].resetFields()
                    // this.tableDataBill = []
                    // this.tableDataAmmeter = []
                    // this.tableDataService = []
                    // this.form.projectIdList = []
                    // console.log(this.form);
                })
                .catch(_=>{})
            },
            checkRules (datas) {
                return new Promise((resolve, reject) => {
                    if(datas.length && datas){
                        for (let index = 0; index < datas.length; index++) {
                            const item = datas[index];
                            console.log(item);
                            if(!item.recordTime){
                                resolve(`请选择电表号：${item.ammeterNo}的本次抄表日期`)
                                return
                            }
                            if(this.$getDay.getTimeUnix(item.recordTime) < this.$getDay.getTimeUnix(item.lastRecordTime)){
                                resolve(`抄表日期填写有误：电表号：${item.ammeterNo}的本次抄表日期小于上次抄表日期`)
                                return
                            }
                            if(item.recordPower === '' || item.recordPower === null){
                                resolve(`请填写电表号：${item.ammeterNo}的本次抄表度数`)
                                return
                            }
                            if((item.remainMoney === '' || item.remainMoney === null) && this.chargeFeeType == 1){
                                resolve(`请填写电表号：${item.ammeterNo}的剩余费用`)
                                return
                            }
                            if((item.prePayAmount === '' || item.prePayAmount === null) && this.chargeFeeType == 1){
                                resolve(`请填写电表号：${item.ammeterNo}的预缴费用`)
                                return
                            }
                            if((item.needPayAmount === '' || item.needPayAmount === null) && this.chargeFeeType == 2){
                                resolve(`请填写电表号：${item.ammeterNo}的应付电费`)
                                return
                            }
                            if(!item.deviceNumByRadio){
                                resolve(`请填写电表号：${item.ammeterNo}的设备数量`)
                                return
                            }
                            if(!item.slotNumByRadio){
                                resolve(`请填写电表号：${item.ammeterNo}的插槽`)
                                return
                            }
                        }
                        resolve()
                    }else{
                        resolve()
                    }
                })
            },
            checkServiceRules (datas) {
                return new Promise((resolve, reject) => {
                    if(datas.length && datas){
                        for (let index = 0; index < datas.length; index++) {
                            const item = datas[index];
                            if(!item.lastRecordTime){
                                resolve(`请选择计费起始时间`)
                                return
                            }
                            if(this.$getDay.getTimeUnix(item.recordTime) < this.$getDay.getTimeUnix(item.lastRecordTime)){
                                resolve(`抄表日期填写有误：本次抄表日期小于上次抄表日期`)
                                return
                            }
                            if(this.form.billFeeWay == '1') {
                                if(item.recordPower === '' || item.recordPower === null){
                                    resolve(`请填写电表号：${item.ammeterNo}的本次抄表度数`)
                                    return
                                }
                                if(item.lastRecordPower === '' || item.lastRecordPower === null){
                                    resolve(`请填写电表号：${item.ammeterNo}的上次抄表度数`)
                                    return
                                }
                                if(item.unitPrice === '' || item.unitPrice === null){
                                    resolve(`请填写项目：${item.projectName}的服务费单价`)
                                    return
                                }
                            }
                            if(item.needPayAmount === '' || item.needPayAmount === null){
                                resolve(`请填写项目：${item.projectName}的服务费`)
                                return
                            }
                        }
                        resolve()
                    }else{
                        resolve()
                    }
                })
            },
            //数组去重
            uniqueArr (arr) {
                try{
                    for(var i=0; i<arr.length; i++){
                        for(var j=i+1; j<arr.length; j++){
                            if(arr[i].stationId==arr[j].stationId){         //第一个等同于第二个，splice方法删除第二个
                                arr.splice(j,1);
                                j--;
                            }
                        }
                    }
                    return arr;
                }catch(err){
                }
            },
            uniqueArrAmmeter (arr) {
                try{
                    for(var i=0; i<arr.length; i++){
                        for(var j=i+1; j<arr.length; j++){
                            if(arr[i].ammeterId==arr[j].ammeterId){         //第一个等同于第二个，splice方法删除第二个
                                arr.splice(j,1);
                                j--;
                            }
                        }
                    }
                    return arr;
                }catch(err){
                }
            },
            groupById(arr,key) {
                const result = {};
                arr.forEach(item => {
                    if (!result[item[key]]) {
                    result[item[key]] = [];
                    }
                    result[item[key]].push(item);
                });
                return result;
            },
        }
    }
</script>

<style lang="scss" scoped>
.scrollBar{
    left: 200px ;
    right: 48px ;
    position: fixed;
    bottom: 70px;
    background: #fff;
    z-index: 100;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    /*width: 0;宽度为0隐藏*/
    width: 0 !important;
    height: 0 !important;
}
/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
    height: 100% !important;
}
/deep/ .el-input-group__prepend{
    height: 32px;
    line-height: 32px;
}
/deep/ .el-date-editor.el-input{
    width: 140px !important;
}
/deep/ .el-main .el-card__body::-webkit-scrollbar {
    /*width: 0;宽度为0隐藏*/
    width: 10px !important;
    height: 10px !important;
    display: block !important;
}
</style>